import { useState } from "react";
import { applyTheme, getTheme } from "@/lib/theme";

const THEMES = [
  { k: "red", label: "R", color: "hsl(0, 95%, 60%)" },
  { k: "green", label: "G", color: "hsl(140, 95%, 58%)" },
  { k: "blue", label: "B", color: "hsl(212, 95%, 60%)" },
];

export function ThemeSelector({ inline = false }) {
  const [theme, setTheme] = useState(getTheme());
  return (
    <div className={inline ? "flex items-center justify-center gap-4 mt-16" : "fixed bottom-10 left-1/2 -translate-x-1/2 flex items-center justify-center gap-4 z-30"} data-testid="theme-selector">
      {THEMES.map((t) => {
        const active = theme === t.k;
        return (
          <button
            key={t.k}
            data-testid={`theme-btn-${t.k}`}
            onClick={() => { applyTheme(t.k); setTheme(t.k); }}
            className="w-11 h-11 text-sm tracking-widest transition-all duration-200"
            style={{ border: `1px solid ${t.color}`, color: active ? "#121212" : t.color, background: active ? t.color : "transparent" }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
